(() => {
  'use strict';
  if (window.__spinkarniaHeaderScrollReady) return;
  window.__spinkarniaHeaderScrollReady = true;

  let ticking = false;
  const sync = () => {
    document.querySelectorAll('[data-sp-header]').forEach(header => {
      header.classList.toggle('is-scrolled', window.scrollY > 18);
    });
    ticking = false;
  };

  const requestSync = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  };

  sync();
  window.addEventListener('scroll', requestSync, { passive: true });
  document.addEventListener('shopify:section:load', requestSync);
})();
